export enum LangCodeTypeEnum {
  TH = "th",
  EN = "en",
}
